//Dependencies............................................
import { Tabs, Form, Dropdown, Button, Space, Input, Checkbox, Modal, Collapse, Tooltip, Select } from 'antd';
import { useEffect, useState } from 'react';
import { ItemType } from 'antd/es/menu/interface';
import { EditOutlined, ExclamationOutlined } from '@ant-design/icons';

//Components..............................................
import DeleteModal from "../../../../GlobalComponents/Modals/DeleteModal";
import { displayToStored, storedToDisplay } from '../../../../../utils/constants';

export default  function Conf20CanMessageConfigField({
    onChange,
    formData,
    formContext,
    errorSchema
    }   :   {
    formData: any,
    onChange: (newFormData: any) => void,
    errorSchema: any,
    formContext: any,
    })
{
    const [selectedConfig, setSelectedConfig] = useState<{ [key: string]: any }>({});

    const [selectedTabName, setSelectedTabName] = useState<string | null>(null);
    const [newTabName, setNewTabName] = useState<string>('');
    const [isEditing, setIsEditing] = useState<boolean>(false);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);

    const canIdFormatItems: ItemType[] = [
        { label: 'standard', key: 'standard' },
        { label: 'extended', key: 'extended' },
    ];

    //const dlcDisplayValues = [0,1,2,3,4,5,6,7,8,12,16,20,24,32,48,64];
    const getDlcOptions = (fd_enable: boolean) => {
        return fd_enable
        ? ["0", "1", "2", "3", "4", "5", "6", "7", "8", "12", "16", "20", "24", "32", "48", "64"]
        : ["0", "1", "2", "3", "4", "5", "6", "7", "8"];
};

    useEffect(() => {
        if (formData) {
            setSelectedConfig(formData);
        }
    }, [formData]);

    const updateConfig = (canId: string, key: string, value: any) => {
        const updatedConfig = {
            ...selectedConfig,
            [canId]: {
                ...selectedConfig[canId],
                [key]: value,
            },
        };
       
        setSelectedConfig(updatedConfig);
        onChange(updatedConfig);
    };

    const handleAddTab = () => {
        let newCanId = `0x00`;
        while (selectedConfig[newCanId]) {
            newCanId = `0x${(Math.random() * 0xFFFFFF).toString(16).toUpperCase().padStart(2, '0')}`;
        }

        const newConfig = {
            ...selectedConfig,
            [newCanId]: {
                can_id_format: '',
                dlc: null,
                timeout_ms: null,
                brs: false,
            },
        };
        setSelectedConfig(newConfig);
        onChange(newConfig);
    };

    const showRenameModal = (canId: string) => {
        setSelectedTabName(canId);
        setNewTabName(canId);
        setIsEditing(true);
    };

    const handleRenameTab = () => {
        if (selectedTabName && newTabName) {
            if (newTabName !== selectedTabName) {
                const updatedConfig = {
                    ...selectedConfig,
                    [newTabName]: { ...selectedConfig[selectedTabName] },
                };
                delete updatedConfig[selectedTabName];

                setSelectedConfig(updatedConfig);
                onChange(updatedConfig);
            }
        }
        setSelectedTabName(null);
        setNewTabName('');
        setIsEditing(false);
    };

    return (
        <>
            <Collapse>
                <Collapse.Panel header="Can Message Config" key="1" >
                    <Tabs
                        type="editable-card"
                        onEdit={(key, action) => {
                            if (action === 'add') {
                                handleAddTab();
                            } else if (action === 'remove') {
                                setSelectedTabName(key as string);
                                setShowDeleteModal(true);
                            }
                        }}
                        addIcon="+"
                    >
                        {Object.keys(selectedConfig).map((canId) =>{
                            const hasErrors = !!(errorSchema as any)?.can_message_config?.[canId];
                            const dlcErrors = !!(errorSchema as any)?.can_message_config?.[canId]?.dlc;
                            const timeoutErrors = !!(errorSchema as any)?.can_message_config?.[canId]?.timeout_ms;

                            return (
                                <Tabs.TabPane
                                    tab={
                                        <span>
                                            <>
                                                <Tooltip title="Rename Tab">
                                                        <EditOutlined
                                                            onClick={() => showRenameModal(canId)}
                                                            style={{ cursor: 'pointer', marginLeft: 5 }}
                                                        />
                                                </Tooltip>
                                                {'  '}{canId}{'  '}
                                                {hasErrors && (
                                                    <ExclamationOutlined
                                                        style={{ color: 'red', fontSize: 15 }}
                                                    />)
                                                }
                                            </>
                                        </span>
                                    }
                                    key={canId}
                                    closable
                                >
                                    <Form layout="horizontal">
                                        <Form.Item label="CAN ID Format">
                                            <Dropdown
                                                menu={{
                                                    items: canIdFormatItems,
                                                    selectable: true,
                                                    onClick: (e) => updateConfig(canId, 'can_id_format', e.key),
                                                }}
                                            >
                                                <Button>
                                                    <Space>{selectedConfig[canId]?.can_id_format || 'Select CAN ID Format'}</Space>
                                                </Button>
                                            </Dropdown>
                                        </Form.Item>
                                        <Form.Item label="DLC">
                                            <Select
                                                value={storedToDisplay[selectedConfig[canId]?.dlc] ?? undefined}
                                                style={{
                                                    width: 120,
                                                    border: dlcErrors ? '1px solid red' : undefined,
                                                }}
                                                onChange={(value) => {
                                                    updateConfig(canId, "dlc", displayToStored[value]);
                                                }}
                                                options={getDlcOptions(formContext.can_bus_config.fd_enable).map(v => ({
                                                    label: v,
                                                    value: v,
                                                }))}
                                            />
                                        </Form.Item>
                                        <Form.Item label="BRS">
                                            <Checkbox
                                                checked={selectedConfig[canId]?.brs}
                                                disabled={!formContext.can_bus_config.fd_enable}
                                                onChange={(e) => updateConfig(canId, 'brs', e.target.checked)}
                                            />
                                        </Form.Item>
                                        <Form.Item label="Timeout (ms)">
                                            <Input
                                                type="number"
                                                value={selectedConfig[canId]?.timeout_ms}
                                                style={{ width: '10%', border: timeoutErrors ? '1px solid red' : undefined }}
                                                onChange={(e) => updateConfig(canId, 'timeout_ms', parseInt(e.target.value, 10))}
                                            />
                                        </Form.Item>
                                    </Form>
                                </Tabs.TabPane>
                            )
                        })}
                    </Tabs>
                </Collapse.Panel>
            </Collapse>
            <Modal
                title="Rename Tab"
                open={isEditing}
                onOk={handleRenameTab}
                onCancel={() => {
                    setSelectedTabName(null);
                    setIsEditing(false);
                }}
            >
                <Input
                    value={newTabName}
                    onChange={(e) => setNewTabName(e.target.value)}
                    placeholder="Enter new tab name"
                />
            </Modal>
            <DeleteModal
                showModal={showDeleteModal}
                onDelete={() => {
                    const newConfig = { ...selectedConfig };
                    delete newConfig[selectedTabName!];
                    setSelectedConfig(newConfig);
                    onChange(newConfig);
                    setShowDeleteModal(false);
                    setSelectedTabName(null);
                }}
                onClose={() => {
                    setShowDeleteModal(false);
                    setSelectedTabName(null);
                }}
            />
        </>
    );
}
